import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';
import React from 'react';

const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0),
}));

export default function PageSuccessPayment() {
    return (
        <>
            <Container>
                <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
                    <Typography variant="h3" paragraph color="#9ED4C0">
                        Payment Successful!
                    </Typography>
                    <Typography sx={{ color: 'text.secondary' }}>
                        The payments has been done successfully.
                    </Typography>
                    <Typography sx={{ color: 'text.secondary' }}>
                        Thanks for being there with us.
                    </Typography>
                    <Box
                        component="img"
                        src="/assets/illustrations/payment_successful.svg"
                        sx={{ height: 340, mx: 'auto', my: { xs: 5, sm: 3 } }}
                    />
                </StyledContent>
            </Container>
        </>
    );
};
